import { Column } from 'typeorm';

export abstract class BaseSchema {
  @Column({ nullable: true })
    schemaVersion: string | null;
  @Column({ nullable: true })
    tenantId: string | null;
  @Column({ nullable: true })
    createdBy: string | null;
  @Column({ nullable: true })
    lastUpdatedBy: string | null;

  constructor(schemaVersion?: string, tenantId?: string, createdBy?: string, lastUpdatedBy?: string) {
    this.schemaVersion = schemaVersion;
    this.tenantId = tenantId;
    this.createdBy = createdBy;
    this.lastUpdatedBy = lastUpdatedBy;
  }
}
